<template>
    <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>{{menuName}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <div class="container">
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-select v-model="form.deptId" placeholder="请选择学校">
                        <el-option
                            v-for="item in depts"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div style="display: inline-block; height:40px;">
                <el-input v-model="form.gradeAndClassName" style="width: 110px;" placeholder="年级班级"></el-input>
            </div>
            <div style="display: inline-block; height:40px;">
                <el-input v-model="form.name" style="width: 110px;" placeholder="姓名"></el-input>
            </div>
            <el-button type="primary" icon="search" @click="common.page = 1;getData()">查询</el-button>
            <el-button type="primary" @click="exportExcel">导出Excel</el-button>
            
            <el-table
                :data="data"
                style="width: 100%;margin-bottom: 20px;"
                row-key="roleId"
                height="550"
                v-loading="loading"
                :element-loading-text="loadingText"
                element-loading-spinner="el-icon-loading"
                element-loading-background = "rgba(255, 255,255,0.7)"
                border
                default-expand-all>
                <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                <el-table-column label="奖品图片"  :show-overflow-tooltip="true" width="100px">
                    <template slot-scope="scope">
                        <div>
                             <el-popover
                                placement="right"
                                title=""
                                trigger="hover">
                                <img :src="scope.row.iconUrl" lazy="loading" style="max-height:250px; max-width:330px"/>
                                <img slot="reference" :src="scope.row.iconUrl"  lazy="loading" style="max-height: 50px;max-width: 130px">
                            </el-popover>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="" label="姓名" width="80px">
                    <template slot-scope="scope">
                        <el-link type="primary" @click="showData(scope.row.studentId)">{{scope.row.studentName}}</el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="className" label="年级班级" width="100px"></el-table-column>
                <el-table-column prop="prizeName" label="兑换奖品" ></el-table-column>
                <el-table-column prop="" label="模式" width="70px">
                    <template slot-scope="scope">
                        <span v-if="scope.row.teacherMode == 0">单教师</span>
                        <span v-else-if="scope.row.teacherMode == 1">多教师</span>
                        <span v-else>无</span>
                    </template>
                </el-table-column>
                <el-table-column prop="exchangeScore" label="兑换星" width="100px"></el-table-column>
                <el-table-column prop="gmtCreate" label="兑换时间" width="140px"></el-table-column>
                <el-table-column prop="" label="兑换状态" width="100px">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status==1">兑换成功</span>
                        <span v-else-if="scope.row.status==0" style="color:red">已撤回</span>
                    </template>
                </el-table-column>
                <el-table-column prop="operateName" label="操作人" width="80px">
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="common.page"
                    :page-size="common.pageSize"
                    :page-sizes="common.allSizes"
                    layout="total,sizes, prev, pager, next, jumper"
                    :total="common.total">
                </el-pagination>
            </div>
        </div>
        <!--详情 -->
        <div v-if="userDetailsVisible">
            <userDetails ref="userDetails"></userDetails>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import http from '../../../../common/http'; 
    import userDetails from '../order/UserDetails.vue';

    export default {
        name:"CommodityList",
        data(){
            return{
                loading:false,
                loadingText:"",

                userDetailsVisible:"",
                menuName:"",
                common:{
                    total:0,            //总数据量
                    pageSize:30,        //每页条数
                    page:1,              //页码
                    isPage:1,            //是否分页
                    allSizes:[30,50,100], //每页条数筛选
                    checkboxArr:[]       //多选框数组
                },
                form:{
                    deptId:"",
                    gradeAndClassName:"",
                    name:"",
                },
                data:[],
                depts:[]
            }
        },
        components: {
            userDetails
        },
        created:function () {
            this.menuName = sessionStorage.getItem("selectMenuItem_key");
            this.getDeptData();
        },
        methods:{
            indexMethod(index) {
                return (this.common.page-1)*this.common.pageSize+(index+1);
            },
            getDeptData(){
                //部门管理
                let url  = this.listDeptUrl;
                let data = {parentId:"0"};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.depts=res.data.list;
                        if(this.depts.length>0){
                           this.form.deptId=this.depts[0].id;
                        }
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            showData(val){
                let url  = this.getUserUrl;
                let data = {
                   id:val
                };
                // console.log(data);
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        // 触发详情界面
                        this.userDetailsVisible = true;
                        this.$nextTick(() => {
                            this.$refs['userDetails'].init(res.data);
                        })
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    console.log(err);
                    this.loading=false;
                });
                
            },
            getData(){
                this.loading=true;
                this.loadingText="正在加载中...";

                let url  = this.exchangePrizeRecordListUrl;
                let data = {
                    isPage:this.common.isPage,
                    page:this.common.page,
                    limit:this.common.pageSize,
                    deptId:this.form.deptId,
                    studentName:this.form.name,
                    className:this.form.gradeAndClassName
                };
                // console.log(data);
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.data = res.data.list;
                       this.common.total=res.data.total;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    console.log(err);
                    this.loading=false;
                });
            },
            selectable(row){
                if(row.id == 1){
                    return false;
                }
                else{
                    return true;
                }
            },
            handleSizeChange(val) {
                this.common.pageSize = val;
                this.common.page = 1;
                this.getData();
            },
            handleCurrentChange(val) {
                this.common.page = val;
                this.getData();
            },
            checkUser(id){
                this.checkVisible = true;
                this.$nextTick(() => {
                    this.$refs['check'].init(id);
                })
            },
            exportExcel(){
                const maxCount = 65535
                if(this.common.total > maxCount){
                    let msg="导出数据超出"+maxCount+"条平台不支持，请缩小数据范围查询，然后再进行导出操作！"
                    this.$commonFn.showTip(msg,3)
                }else{
                    this.exportData()
                }
            },
            exportData(){
                this.loading=true;
                this.loadingText="正在导出中，导出过程时间可能会比较长，请耐心等待";
                let url=this.exchangePrizeRecordExcelUrl;
                console.log("url:"+url);
                let param = new URLSearchParams();
                param.append('deptId', this.form.deptId);
                param.append('userName', this.form.name);
                param.append('studentName', this.form.name);
                param.append('className', this.form.gradeAndClassName);

                axios({
                    method: "post",
                    url: url,
                    data: param,
                    responseType: "blob"
                }).then(res => {
                    const link = document.createElement("a");
                    let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
                    link.style.display = "none";
                    link.href = URL.createObjectURL(blob);
                    link.setAttribute("download", '兑奖记录.xls');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    this.loading=false;
                }).catch(error => {
                    // this.$Notice.error({
                    //     title: "错误",
                    //     desc: "系统数据错误"
                    // });
                    console.log(error); 
                    this.loading=false;
                });
           }
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/shop/exchangePrize/list.vue